module.exports = __webpack_public_path__ + "img/bg_img_placeholder.6a456a71.jpg";